import React, { ReactElement, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchConfiguration, fetchMapCategories, fetchObjects } from '../../map/actions';
import MapPage from '../../map';
import { MapState } from '../../map/reducer';
import { SlugRouter } from './slug-router';
import { fetchOrganizersAction } from '../../../../service/organizers';

export default function MapRouter(): ReactElement {
  const { isLoadingObjects, isLoadingConfiguration } = useSelector((state: { map: MapState }) => ({
    isLoadingConfiguration: state.map.loadingConfiguration,
    isLoadingObjects: state.map.loadingObjects,
  }));
  const dispatch = useDispatch();
  useEffect(() => {
    fetchConfiguration(dispatch)();
    fetchMapCategories(dispatch)();
    fetchObjects(dispatch)();
    fetchOrganizersAction(dispatch);
  }, [dispatch]);
  return (
    <>
      {isLoadingObjects || isLoadingConfiguration ? <div className="spinner ajax-progress-fullscreen" /> : null}
      <Routes>
        <Route path="/sjokort" element={<MapPage />} />
        <Route path="/sjokort/:slug" element={<SlugRouter />} />
        <Route path="*" element={<MapPage />} />
      </Routes>
    </>
  );
}
